import PromoPage from './promo'

export default PromoPage
